/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataGetUserPointsHistoryPageRespVo } from './PageDataGetUserPointsHistoryPageRespVo';
import {
    PageDataGetUserPointsHistoryPageRespVoFromJSON,
    PageDataGetUserPointsHistoryPageRespVoFromJSONTyped,
    PageDataGetUserPointsHistoryPageRespVoToJSON,
    PageDataGetUserPointsHistoryPageRespVoToJSONTyped,
} from './PageDataGetUserPointsHistoryPageRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataGetUserPointsHistoryPageRespVo
 */
export interface ResponsePageDataGetUserPointsHistoryPageRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataGetUserPointsHistoryPageRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataGetUserPointsHistoryPageRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataGetUserPointsHistoryPageRespVo}
     * @memberof ResponsePageDataGetUserPointsHistoryPageRespVo
     */
    data?: PageDataGetUserPointsHistoryPageRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataGetUserPointsHistoryPageRespVo interface.
 */
export function instanceOfResponsePageDataGetUserPointsHistoryPageRespVo(value: object): value is ResponsePageDataGetUserPointsHistoryPageRespVo {
    return true;
}

export function ResponsePageDataGetUserPointsHistoryPageRespVoFromJSON(json: any): ResponsePageDataGetUserPointsHistoryPageRespVo {
    return ResponsePageDataGetUserPointsHistoryPageRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataGetUserPointsHistoryPageRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataGetUserPointsHistoryPageRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataGetUserPointsHistoryPageRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataGetUserPointsHistoryPageRespVoToJSON(json: any): ResponsePageDataGetUserPointsHistoryPageRespVo {
    return ResponsePageDataGetUserPointsHistoryPageRespVoToJSONTyped(json, false);
}

export function ResponsePageDataGetUserPointsHistoryPageRespVoToJSONTyped(value?: ResponsePageDataGetUserPointsHistoryPageRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataGetUserPointsHistoryPageRespVoToJSON(value['data']),
    };
}

